<template>
    <div id="answer">
        <div class="app-container mb-5" v-if="!$global.loading && errorMessage === null">
            <div class="container w-75 ml-auto mr-auto mt-4" style="padding: 0">
                <div class="justify-content-between d-flex">
                    <div>
                        <div class="d-flex">
                            <div style="font-size: 19px" class="page-title d-flex mt-auto mb-auto">
                                <b>{{ providerData.name }}</b>
                            </div>

                            <div v-if="auraForm.provider.apidae_source !== null" class="d-flex">
                                <div class="mt-auto mb-auto ml-2 mr-2">—</div>
                                <div class="mt-auto mb-auto">
                                    {{ auraForm.provider.apidae_source.external_id }}
                                </div>

                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" icon target="_blank" :href="'https://base.apidae-tourisme.com/gerer/objet-touristique/' + auraForm.provider.apidae_source.external_id + '/consulter/'">
                                            <v-icon>open_in_new</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Voir sur Apidae</span>
                                </v-tooltip>
                            </div>
                        </div>

                        <div>
                            <span>
                                Réponse de <b>{{ providerData.contact.first_name }} {{ providerData.contact.last_name }}</b>
                                (<a :href="'mailto:' + providerData.contact.email + '?subject=Au sujet de ' + providerData.name">{{ providerData.contact.email }}</a>)<br />
                                Reçue le {{ formatDate(auraForm.answered_at) }}
                            </span>
                        </div>
                    </div>

                    <div class="mt-auto">
                        <div v-if="auraForm.status === 'ANSWERED'">
                            <v-btn class="default-button label-button"
                                   :disabled="!hasToken"
                                   v-if="auraForm.provider.apidae_source !== null"
                                   @click="updateApidae">
                                Mettre à jour la fiche agence sur Apidae
                            </v-btn>

                            <v-btn class="default-button label-button" :disabled="!hasToken" v-else @click="createApidae">
                                Créer la fiche agence sur Apidae
                            </v-btn>
                        </div>

                        <div v-if="auraForm.status === 'UPDATED_AGENCY'">
                            <div v-for="(product, index) in providerData.products">
                                <v-btn class="default-button label-button mb-2"
                                       :disabled="!hasToken"
                                       v-if="auraForm['state_sej_' + (index+1)] === 'ERROR' || auraForm['state_sej_' + (index+1)] === null"
                                       @click="createSej(index)">
                                    Créer le séjour : {{ product.name }}
                                </v-btn>
                            </div>
                        </div>
                    </div>
                </div>

                <v-alert type="info"
                         text
                         class="container mt-5 mb-5"
                         v-if="auraForm.status === 'UPDATED_AGENCY' || auraForm.status === 'FINISHED' ">
                    <div>
                        La fiche agence <b><a style="color: #1976d2 !important;" target="_blank" :href="'https://base.apidae-tourisme.com/gerer/objet-touristique/' + auraForm.provider.apidae_source.external_id + '/consulter/'">{{ auraForm.provider.apidae_source.external_id  }}</a></b> a été mise à jour le {{ formatDate(auraForm.updated_at) }}
                    </div>

                    <div v-if="auraForm.state_sej_1 !== null">
                        <div v-if="auraForm.state_sej_1 === 'ERROR'">
                            La création du séjour 1 est en erreur.
                        </div>

                        <div v-else>
                            Le séjour <b><a style="color: #1976d2 !important;" target="_blank" :href="'https://base.apidae-tourisme.com/gerer/objet-touristique/' + auraForm.state_sej_1 + '/consulter/'">{{ auraForm.state_sej_1  }}</a></b> a été créé
                        </div>
                    </div>

                    <div v-if="auraForm.state_sej_2 !== null">
                        <div v-if="auraForm.state_sej_2 === 'ERROR'">
                            La création du séjour 2 est en erreur.
                        </div>

                        <div v-else>
                            Le séjour <b><a style="color: #1976d2 !important;" target="_blank" :href="'https://base.apidae-tourisme.com/gerer/objet-touristique/' + auraForm.state_sej_2 + '/consulter/'">{{ auraForm.state_sej_2  }}</a></b> a été créé
                        </div>
                    </div>

                    <div v-if="auraForm.state_sej_3 !== null">
                        <div v-if="auraForm.state_sej_3 === 'ERROR'">
                            La création du séjour 3 est en erreur.
                        </div>

                        <div v-else>
                            Le séjour <b><a style="color: #1976d2 !important;" target="_blank" :href="'https://base.apidae-tourisme.com/gerer/objet-touristique/' + auraForm.state_sej_3 + '/consulter/'">{{ auraForm.state_sej_3 }}</a></b> a été créé
                        </div>
                    </div>
                </v-alert>

                <div class="mt-5">
                    <v-alert type="error" text class="container" v-if="!hasToken">
                        Votre connexion avec Apidae a expirée. Merci de vous reconnecter pour pouvoir utiliser le service
                        d'écriture Apidae.
                        <div class="text-center mt-3 mb-3">
                            <v-btn class="default-button" @click="loginAgain">Se reconnecter</v-btn>
                        </div>
                    </v-alert>
                </div>
            </div>

            <aura-form
                :disabled="true"
                :loaded-provider-data="providerData">
            </aura-form>
        </div>
    </div>
</template>

<script>
import AuraForm from "./AuraForm"

export default {
    name: "AuraAnswer",
    components: {AuraForm},
    data() {
        return {
            token: null,
            auraForm: null,
            providerData: null,
            errorMessage: null,
            hasToken: false,
            apiUrl: process.env.VUE_APP_API_URL
        }
    },
    methods :{
        getAnswer() {
            this.$global.loading = true

            this.$http.get('auth/aura/answer/' + this.token).then(res => {
                this.auraForm     = res.body.data.form
                this.providerData = JSON.parse(this.auraForm.json)
                this.hasToken     = res.body.data.hasToken

                this.$global.loading = false
            })
        },
        formatDate(date) {
            if (!date) return null

            return this.$moment(date).format('DD/MM/YYYY à HH[h]mm')
        },
        loginAgain() {
            window.location.href = this.apiUrl + '/sso/attempt/'+ btoa(window.location.href)
        },
        createApidae() {
            this.$global.loading = true

            let payload = {
                formId: this.auraForm.id
            }

            this.$http.post('auth/aura/create-agency', payload).then(res => {
                this.getAnswer()
            })
        },
        updateApidae() {
            this.$global.loading = true

            let payload = {
                formId: this.auraForm.id
            }

            this.$http.post('auth/aura/update-agency', payload).then(res => {
                this.getAnswer()
            })
        },
        createSej(index) {
            this.$global.loading = true

            let payload = {
                formId: this.auraForm.id,
                productIndex: index
            }

            this.$http.post('auth/aura/create-sej', payload).then(res => {
                this.getAnswer()
            })
        }
    },
    created() {
        this.token = this.$route.params.token

        this.getAnswer()
    }
}
</script>